// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "iframe {\n  width: 100% !important;\n  border: none !important;\n  margin: 0px !important;\n  padding: 0px !important;\n}\n.S9gUrf-YoZ4jf {\n  width: 110% !important;\n}\n.S9gUrf-YoZ4jf .nsm7Bb-HzV7m-LgbsSe {\n  margin-left: 10px;\n  margin-top: 3px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
